import React, { type FC } from 'react';

import { Popover, PopoverProps } from 'wix-ui-tpa/cssVars';

import { CloseSmall } from '@wix/wix-ui-icons-common/on-stage';
import { useTranslation } from '@wix/yoshi-flow-editor';

import { Markdown } from '../Markdown';

import { st, classes } from './NotificationBubble.st.css';

export interface NotificationBubbleProps extends PopoverProps {
  id?: string;
  textContent?: string;
  hasShadow?: boolean;
  bubbleClassName?: string;
  onClick?: () => void;
  onClose?: () => void;
}

export const NotificationBubble: FC<NotificationBubbleProps> = ({
  id,
  children,
  textContent,
  onClick,
  onClose,
  hasShadow,
  bubbleClassName,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Popover
      showArrow={false}
      className={st(classes.popoverRoot)}
      contentClassName={st(
        classes.popoverContent,
        {
          bubbleHasShadow: hasShadow,
        },
        bubbleClassName,
      )}
      {...props}
    >
      <Popover.Element>
        <div role="presentation" aria-hidden="true">
          {children}
        </div>
      </Popover.Element>
      <Popover.Content>
        <div
          className={st(classes.bubble)}
          role="tooltip"
          aria-label={t('app.widget.ariallabel.notificationTooltip')}
        >
          <button onClick={onClick} className={st(classes.bubbleContent)}>
            <div id={id} className={st(classes.bubbleText)}>
              <Markdown
                inline
                className={st(classes.markdown)}
                text={textContent ?? ''}
              />
            </div>
          </button>
          <button
            className={st(classes.closeBubble)}
            onClick={onClose}
            aria-label={t('app.widget.ariallabel.closeNotification')}
          >
            <CloseSmall className={st(classes.closeBubbleIcon)} />
          </button>
        </div>
      </Popover.Content>
    </Popover>
  );
};
